import React from 'react';

import { cssMap, cx } from '@atlaskit/css';
import { type XCSS } from '@atlaskit/primitives';

import { TBody as PTBody, type TBodyProps } from '../../ui/primitives/tbody';

const bodyStyles = cssMap({
	root: { position: 'relative', border: 'none' },
});

/**
 * __Table body__
 */
export const TBody = React.forwardRef<HTMLTableSectionElement, TBodyProps>(
	({ children, xcss: customXcss, ...props }, ref) => {
		return (
			// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
			<PTBody xcss={cx(bodyStyles.root, customXcss as XCSS)} ref={ref} {...props}>
				{children}
			</PTBody>
		);
	},
);
